import styled from "styled-components";

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.shades[0]};
  border-radius: ${({ theme }) => theme.radius}px;
  box-shadow: ${({ theme }) => theme.boxShadow};
  padding: ${({ theme }) => theme.spacing * 4}px;
  display: grid;
  grid-template-columns: 90px 1fr max-content;
  grid-column-gap: ${({ theme }) => theme.spacing * 2}px;
  align-items: center;
  .image {
    > img {
      width: 90px;
      aspect-ratio: 16/9;
      object-fit: cover;
      border-radius: ${({ theme }) => theme.radius}px;
    }
    width: 90px;
    aspect-ratio: 16/9;
    border-radius: ${({ theme }) => theme.radius}px;
    background-color: ${({ theme }) => theme.colors.gray[100]};
    display: flex;
    align-items: center;
    justify-content: center;
    > svg {
      > g, path {
        fill: ${({ theme }) => theme.colors.gray[400]}
      }
    }
  }
  .displayName {
    color: ${({ theme }) => theme.colors.gray[900]};
    font-size: 16px;
    margin: 0;
    font-weight: 700;
  }
  > button {
    padding: ${({ theme }) => theme.spacing * 2}px;
  }
`;
